import ReactDOM from "react-dom";
import React from "react";
import PricingList from "./Pricing/";
import BrainIcon from "./Icons/Brain.icon";

const init = () => {
  const container = document.getElementById("pricingList");
  if (container) {
    ReactDOM.render(<PricingList />, container);
  }
};

export default init;



// WEBPACK FOOTER //
// ./resources/assets/js/app/pricingList.js